<div class="workspace no-back-btn">
  <div class="d-flex flex-row">
    <div class="header-title">
      <div class="main-title">{{header}}</div>
      <div class="sub-title">{{subheader}}</div>
    </div>
    <div class="header-tab">
      <achoo-tabs [(selectedTabKey)]="tabKey" (tabClicked)="replaceTab($event)" #accountSettingTabs>
        <achoo-tab [tabKey]="accountTabs.USER_SETTINGS" class="user-settings">
          <ng-template tabHeading>
            <a>{{'account_settings.tab_header.user_settings' | translate}}</a>
          </ng-template>
        </achoo-tab>
        <achoo-tab [tabKey]="accountTabs.BILLING" class="billing">
            <ng-template tabHeading>
              <a>{{'account_settings.tab_header.billing' | translate}}</a>
            </ng-template>
          </achoo-tab>
      </achoo-tabs>
    </div>
  </div>
  <div class="horizontal-seperator"></div>
  <div class="tab-content">
    <user-settings *ngIf="tabKey === accountTabs.USER_SETTINGS"></user-settings>
  </div>
  <div class="tab-content">
    <user-billing-details #userBillingDetails *ngIf="tabKey === accountTabs.BILLING" 
                          [userBilling]="userBilling"
                          [shouldReloadPage]="shouldReloadPage"
                          (requestReloadBilling)="reloadBilling()"
                          [userMonthlyUsage]="userMonthlyUsage">
    </user-billing-details>
  </div>
</div>

<achoo-popup #ErrorNotification
             [isNotification]="true"
             [modelTitle]="'notification.error' | translate">
  <span>{{errorMessage}}</span>
</achoo-popup>




// WEBPACK FOOTER //
// ./src/app/main/account-setting/account-setting.component.html